class ProfileDropdown extends HTMLElement {
  static observedAttributes = ["user", "tenant"];

  constructor() {
    super();
  }

  connectedCallback() {
    this.render();

    this.addEventListener("click", this.toggle);
  }

  disconnectedCallback() {
    this.querySelector("#toggle-profile-dropdown").removeEventListener(
      "click",
      this.toggle,
    );
    document.removeEventListener("click", this.close);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.render();
  }

  get user() {
    return {
      name: this.getAttribute("data-user-name"),
      emailHash: this.getAttribute("data-user-email"),
    };
  }

  get tenant() {
    const tenants = JSON.parse(this.getAttribute("data-tenants"));
    if (!tenants) return { name: "No tenant" };
    const activeTenant = this.getAttribute("data-active-tenant");
    return tenants.find((tenant) => tenant.id === activeTenant);
  }

  get tenantList() {
    const tenants = JSON.parse(this.getAttribute("data-tenants"));
    const activeTenant = this.getAttribute("data-active-tenant");
    if (!tenants) return [];
    return tenants.map((tenant) => {
      return {
        ...tenant,
        active: tenant.id === activeTenant,
      };
    });
  }

  get permissions() {
    const perms = this.getAttribute("data-permissions");
    if (!perms) return [];
    try {
      return JSON.parse(perms);
    } catch (e) {
      return [];
    }
  }

  hasPermission(permissionName) {
    return this.permissions.includes(permissionName);
  }

  // Dropdown menu, show/hide based on menu state.

  // Entering: "transition ease-out duration-100"
  //   From: "transform opacity-0 scale-95"
  //   To: "transform opacity-100 scale-100"
  // Leaving: "transition ease-in duration-75"
  //   From: "transform opacity-100 scale-100"
  //   To: "transform opacity-0 scale-95"

  get menuItems() {
    const items = [
      { label: "Admin", href: "/admin", permission: "admin.access" },
      { label: "Profile", href: "/profile" },
      { label: "Settings", href: "/settings" },
      { label: "Sign out", href: "/logout" },
    ];

    return items
      .filter((item) => !item.permission || this.hasPermission(item.permission))
      .map((item, index) => {
        return `
        <a
          href="${item.href}"
          hx-boost="true"
          hx-swap="innerHTML transition:true"
          class="block px-4 py-2 text-base text-gray-700"
          role="menuitem"
          tabindex="-1"
          id="user-menu-item-${index}"
        >${item.label}</a>
      `;
      })
      .join("");
  }

  render() {
    this.innerHTML = `
      <div>
        <div class="relative ml-3">
          <div>
            <button id="toggle-profile-dropdown" type="button" class="relative flex gap-2 max-w-xs items-center rounded-full bg-none text-base focus:outline-none id="user-menu-button" aria-expanded="false" aria-haspopup="true">
              <div class="text-right">
                <p class="font-medium">${this.user.name == "Duva" ? "Robert Lidberg" : this.user.name}</p>
                <p>${this.tenant.name}
                  <span class="inline-flex">
                    <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 1V7.66667M3 7.66667L5 5.66667M3 7.66667L1 5.66667" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  <span>
                </p>
              </div>
              <span class="absolute -inset-1.5"></span>
              <span class="sr-only">Open user menu</span>
              <img loading="lazy" class="h-8 w-8 rounded-md" src="${this.user.name == "Duva" ? "/assets/images/robert.jpeg" : "https://www.gravatar.com/avatar/" + this.user.emailHash + "?s=64&d=identicon"}" alt="">
            </button>
          </div>

          <div
            id="profile-dropdown"
            class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="user-menu-button"
            style="display: ${this.active ? "block" : "none"}"
            tabindex="-1"
          >
            <!-- Active: "bg-gray-100", Not Active: "" -->
            ${this.tenantList
              .map((tenant, index) => {
                return `
                  <p
                    class="tenant-menu-item block px-4 py-2 text-base ${tenant.active ? "text-black" : "text-gray-400"} hover:text-black border-b border-gray-900/10 cursor-pointer"
                    role="menuitem"
                    tabindex="-1"
                    id="tenant-menu-item-${index}"
                    data-tenant-id="${tenant.id}"
                    hx-post="/switch-tenant"
                    hx-vals='{"tenant_id": "${tenant.id}"}'
                  >
                    ${tenant.name}
                  </p>`;
              })
              .join("")}
            ${this.menuItems}
          </div>
        </div>
      </div>
      `;
  }

  toggle = (event) => {
    this.active ? this.close(event) : this.open(event);
  };

  open = () => {
    this.active = true;
    this.querySelector("#profile-dropdown").style.display = "block";

    setTimeout(() => {
      document.addEventListener("click", this.close);
    }, 0);
  };

  close = (event) => {
    const isAnchor = event.target.tagName.toLowerCase() === "a";
    const isProfileToggle = this.querySelector(
      "#toggle-profile-dropdown",
    ).contains(event.target);
    const isOutside = !this.contains(event.target);

    if (isAnchor || isProfileToggle || isOutside) {
      this.active = false;
      this.querySelector("#profile-dropdown").style.display = "none";
      document.removeEventListener("click", this.close);
    }
  };
}

customElements.define("profile-dropdown", ProfileDropdown);
